<template>
  <div>
    <van-nav-bar
      title="企业信息"
      left-text="修改密码"
      right-text="退出登录"
      right-arrow
      @click-left="$router.push('/client-repwd')"
      @click-right="handleLogout()"
    />
    <van-form validate-first @submit="handleModifyClient">
      <van-col :span="24" style="text-align: center;">
        <h4>{{ userInfo.name }}</h4>
      </van-col>
      <van-col :span="24">
        <base-textarea v-model="form.qualification" size="large" label="资质信息"
                       :maxlength="300"
                       :rules="[{ required: true, message: '请输入您的资质信息' }]"
        />
      </van-col>
      <van-col :span="22" :offset="1">
        <br>
        <base-button size="large" native-type="submit" :round="true">修改资质信息</base-button>
      </van-col>
      <van-col :span="22" :offset="1" style="margin-top: 20px;">
        <span style="color: red; font-weight: bold;">资质附件上传：</span>
      </van-col>
      <van-col :span="24" style="text-align: center;">
        <van-progress
          v-if="uploading"
          :percentage="uploadingPercentage"
          :pivot-text="uploadingMsg"
          color="#13ce66"
        />
        <van-uploader v-model="fileList" accept="*" :max-count="99" upload-text="请选择文件"
                      :disabled="!canUpload" :deletable="canUpload" multiple :after-read="afterRead"
                      :before-delete="beforeDelete"
        />
      </van-col>
    </van-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import lrz from 'lrz'
import { logoutOfClientTerm, modifyOfClientTerm, getAncDocListOfClientTerm,
  uploadAncDocOfClientTerm, deleteAncDocOfClientTerm } from '@/api/settings/client'
export default {
  data() {
    return {
      form: {
        id: 0,
        qualification: ''
      },
      fileList: [],
      LIMIT_SIZE: 1024 * 1024 * 10, // 上传文件大小不能超过10MB
      canUpload: true,
      uploading: false,
      uploadingPercentage: 0,
      uploadingMsg: ''
    }
  },
  computed: {
    ...mapGetters(['token', 'userInfo'])
  },
  mounted() {
    if (!this.userInfo || !this.userInfo.id) {
      this.error('请先登录')
      this.$router.push('/clogin')
      return
    }
    this.form.id = this.userInfo.id
    this.form.qualification = this.userInfo.qualification
    this.queryAncDocListOfClientTerm()
  },
  methods: {
    handleModifyClient() {
      modifyOfClientTerm(this.form).then(resp => {
        this.success(resp.msg)
      })
    },
    handleLogout() {
      this.confirm('确定退出系统吗？').then(async() => {
        logoutOfClientTerm().then(resp => {
          this.success(resp.msg)
          this.$router.push('/clogin')
        })
      }).catch(_ => {})
    },
    queryAncDocListOfClientTerm() {
      getAncDocListOfClientTerm({
        client_id: this.form.id
      }).then(resp => {
        const rows = resp.rows || []
        this.fileList = []
        rows.forEach(row => {
          this.fileList.push({
            id: row.id,
            status: 'done',
            url: `${this.BACKEND_API}/${row.anc_doc}?token=${this.token}`
          })
        })
      })
    },
    beforeDelete(file) {
      return new Promise((resolve, reject) => {
        this.confirm('确定删除文件吗？').then(() => {
          deleteAncDocOfClientTerm({
            id: file.id
          }).then(resp => {
            this.success(resp.msg)
            resolve()
          }).catch(() => {
            reject()
          })
        }).catch(() => {
          reject()
        })
      })
    },
    async afterRead(file) {
      this.canUpload = false
      this.uploading = true
      this.uploadingPercentage = 0
      let files = []
      if (file instanceof Array) {
        files = file
      } else {
        files.push(file)
      }
      for (let i = 0; i < files.length; i++) {
        this.uploadingPercentage = parseFloat(parseFloat((i + 1) / files.length * 100).toFixed(2))
        this.uploadingMsg = ` ${i + 1}/${files.length}`

        const originFile = files[i]
        const suffixPos = originFile.file.name.lastIndexOf('.')
        const suffixName = originFile.file.name.substring(suffixPos + 1)
        const isImg = this.CONST.UPLOAD.IMAGE_TYPES.find(type => type === suffixName.toLowerCase()) != null
        if (isImg) {
          const rst = await lrz(originFile.file)
          await this.uploadFile(originFile, rst.formData).catch(msg => {
            this.error(msg)
          })
        } else {
          const formData = new FormData()
          formData.append('file', originFile.file)
          await this.uploadFile(originFile, formData).catch(msg => {
            this.error(msg)
          })
        }
      }
      this.canUpload = true
      this.uploading = false
      this.uploadingPercentage = 100
    },
    uploadFile(originFile, formData) {
      return new Promise((resolve, reject) => {
        if (originFile.file.size > this.LIMIT_SIZE) {
          this.error('上传失败！请您上传10M以下的文件')
          this.delFile(originFile)
          reject('上传失败！请您上传10M以下的文件')
        } else {
          formData.append('client_id', this.form.id)
          uploadAncDocOfClientTerm(formData).then(resp => {
            if (resp.success) {
              if (resp.obj) {
                originFile.id = resp.obj.id
              }
              this.success(resp.msg)
              resolve()
            } else {
              console.error('文件上传失败')
              this.delFile(originFile)
              reject('文件上传失败')
            }
          }).catch(() => {
            console.error('文件上传失败')
            this.delFile(originFile)
            reject('文件上传失败')
          })
        }
      })
    },
    delFile(file) {
      const index = this.fileList.indexOf(file)
      if (index !== -1) {
        this.fileList.splice(index, 1)
      }
    }
  }
}
</script>

<style>
.block-card {
  margin: 0 12px 0;
  overflow: hidden;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/client-index.vue